import type { AnchorHTMLAttributes, ReactNode } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { cx } from '../cx'
import { Icon } from '../Icon/Icon'
import styles from './Link.module.css'

export function Link({
  href,
  variant = 'default',
  external,
  state,
  className,
  children,
  ...rest
}: Omit<
  AnchorHTMLAttributes<HTMLAnchorElement>,
  'href' | 'target' | 'rel' | 'title'
> & {
  href: string
  variant?: 'default' | 'quiet'
  external?: boolean
  state?: unknown
  children: ReactNode
}) {
  return (
    <RouterLink
      {...rest}
      to={href}
      state={state}
      className={cx(styles.link, className)}
      data-variant={variant}
      {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
    >
      {children}
      {external && <Icon name="external-link" size="icon-embedded" />}
    </RouterLink>
  )
}
